import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from 'react-intl';
import get from 'get-value';
import {SubmissionError} from 'redux-form';
import moment from 'moment';
import ExportOrderForm from './ExportOrderForm';
import {createOrderExport, downloadExport, fetchOrderExport} from '../../../actions/orders/actionOrderExport';
import Loader from '../../Loader';
import {
    ORDER_EXPORT_FORM_FIELD_CHARSET,
    ORDER_EXPORT_FORM_FIELD_TYPE,
    XLS
} from '../../../constants/exportConstant';
import {FORM_FIELD_PFX, FORM_FIELD_SFX} from '../../../constants/formConstants';
import PageHeader from '../../common/PageHeader';
import checkRoles from '../../common/roleChecker/RoleChecker';

class ExportOrderPage extends Component {
    componentDidMount() {
        this.props.fetchOrderExport();
    }

    handleSubmit = (values) => {
        const pfx = get(values, 'pfxNumber', '').length;
        const sfx = get(values, 'sfxNumber', '').length;

        if (pfx > 0 && sfx === 0) {
            throw new SubmissionError({
                [FORM_FIELD_SFX]: 'Fill complete ticket number'
            })
        }

        if (pfx === 0 && sfx > 0) {
            throw new SubmissionError({
                [FORM_FIELD_PFX]: 'Fill complete ticket number'
            })
        }
        const temp = JSON.parse(JSON.stringify((({ assigned, dealer = {}, status, solutionGroup }) => {
            const { dealerNumber, dealerName } = dealer;
            return ({
                lastEditor: assigned ? assigned.trim() : undefined,
                dealerNumber: dealerNumber ? dealerNumber.trim() : undefined,
                dealerName: dealerName ? dealerName.trim() : undefined,
                status,
                solutionGroup
            });
        })(values)));

        if (pfx || sfx) {
            temp.ticketNumber = `${values.pfxNumber}-${values.sfxNumber}`;
        }

        const exportFilter = {};
        exportFilter.filter = [];
        for (let key in temp) {
            if (temp.hasOwnProperty(key)) {
                if (key === 'lastEditor') {
                    temp[key].split(' ').forEach(element => exportFilter.filter.push({ id: key, value: element }));

                } else {
                    exportFilter.filter.push({ id: key, value: temp[key] })
                }
            }
        }

        if (values.from) {
            exportFilter.from = moment(values.from).add(12, 'hours').toISOString().substr(0, 10);
        }
        if (values.to) {
            exportFilter.to = moment(values.to).add(12, 'hours').toISOString().substr(0, 10);
        }
        exportFilter.type = values.type;
        if (!exportFilter.type) {
            exportFilter.type = XLS;
        }
        exportFilter.charset = values.charset;
        this.props.createOrderExport(exportFilter);
    };

    downloadExport = () => {
        this.props.downloadExport(this.props.exportRecord);
    };

    render() {
        const { isLoadingExport, charSets } = this.props;

        if (isLoadingExport) {
            return <Loader/>;
        }

        return (
            <div className="container-fluid">
                <PageHeader title={<FormattedMessage id="spareParts.export.header" defaultMessage="Export"/>}/>
                <ExportOrderForm onSubmit={this.handleSubmit}
                                 downloadExport={this.downloadExport}
                                 form={'orderExportForm'}
                                 initialValues={{
                                     [ORDER_EXPORT_FORM_FIELD_TYPE]: XLS,
                                     [ORDER_EXPORT_FORM_FIELD_CHARSET]: charSets[0]
                                 }}
                />
            </div>
        );
    }
}

ExportOrderPage.propTypes = {
    isLoadingExport: PropTypes.bool.isRequired,
    exportRecord: PropTypes.object.isRequired,
    fetchOrderExport: PropTypes.func.isRequired,
    createOrderExport: PropTypes.func.isRequired,
    downloadExport: PropTypes.func.isRequired,
    charSets: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
    isLoadingExport: state.orderExportTickets.isLoadingExport,
    exportRecord: state.orderExportTickets.exportRecord,
    charSets: state.profile.userDetail.charSets,
});

export default checkRoles(connect(mapStateToProps, {
    fetchOrderExport,
    createOrderExport,
    downloadExport,
})(injectIntl(ExportOrderPage)),['SP_EDITOR', 'SP_SG_EDITOR']);
